import { render, staticRenderFns } from "./OnTripBlock.vue?vue&type=template&id=6c03b5d8&scoped=true"
import script from "./OnTripBlock.vue?vue&type=script&lang=js"
export * from "./OnTripBlock.vue?vue&type=script&lang=js"
import style0 from "./OnTripBlock.vue?vue&type=style&index=0&id=6c03b5d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c03b5d8",
  null
  
)

export default component.exports